import { Row } from './List/Row'
import { ListHead } from './List/ListHead'
import { AddTemplateFormModal } from './AddNew/AddTemplateFormModal'
import { TextTemplateInputValue } from './TemplateValue/Text/Input'
import { TextTemplateDisplayValue } from './TemplateValue/Text/Display'
import type { Components } from './Context'

export const components: Components = {
  ListRow: Row,
  ListHead,
  AddNewTemplateButton: AddTemplateFormModal,
  TemplateInputValue: TextTemplateInputValue,
  TemplateDisplayValue: TextTemplateDisplayValue,
}
